import makeApiCall from "./axiosIndex";
const STATIC_FILES_DATA = {
  docKeys: [
    {
      order: 0,
      module: "Budget",
      moduleFileType: "signature.png"
    }
  ],
};

const budgetApis = {
  budgetCreationMethod: (data: any) =>
    makeApiCall({
      url: "/budget/createBudget",
      method: "post",
      data,
    }),
  createNewVersionBudget: (data: any) =>
    makeApiCall({
      url: "/budget/createNewVersionBudget",
      method: "post",
      data,
    }),
  getBudgetBySite: (siteId: number | number[] | string | string[], contractorId?: string | number): Promise<any> => {
    // Convert to comma-separated string if array, otherwise use as is
    const siteParam = Array.isArray(siteId)
      ? siteId.join(',')
      : siteId;
    const params: any = { site: siteParam };
    if (contractorId) {
      params.contractorId = contractorId;
    }
    return makeApiCall<any>({
      method: "get",
      url: `/budget/getbySite`,
      params,
    });
  },
  fetchBudgetAll: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/budget/getAll",
    }),
  fetchBudgetById: (id: string): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/budget/id/${id}`,
    }),
  pendingApprovals: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/budget/pendingApprovals`,
      // params: { status }
    }),
  approveBudget: (headerId: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      headerId,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "put",
      url: `/budget/approveBudget`,
      data: formData,
    });
  },
  rejectBudget: (headerId: number, reason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      headerId,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "put",
      url: `/budget/rejectBudget`,
      data: formData,
    });
  },
  budgetSpendAnalysis: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/budget-dashboard/budgetSpendAnalysis",
      method: "post",
      data: data,
    }),
  materialWiseSpendAnalysis: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/budget-dashboard/materialWiseSpendAnalysis",
      method: "post",
      data: data,
    }),
  materialWiseBudgetOverRun: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/budget-dashboard/materialWiseBudgetOverRun",
      method: "post",
      data: data,
    }),
  holdBudget: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/budget/holdBudget`,
      data,
    }),
  completeBudget: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/budget/completeBudget`,
      data,
    }),
  inactivateBudget: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/budget/inactivateBudget`,
      data,
    }),
  fetchBudgetListPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/budget/paginationList",
      method: "get",
      params,
    }),
  fetchBudgetPaginationPendingApprovals: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/budget/paginationPendingApprovals",
      method: "get",
      params,
    }),
  fetchStatusFilterOptions: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/budget/status`,
    }),
  fetchBudgetCategoryList: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/budget/categoryList`,
    }),
  bomBulkUploadCreate: (data: any) =>
    makeApiCall({
      url: "/budget/bomBulkUploadValidate",
      method: "post",
      data,
    }),
  budgetLineBulkUploadValidate: (data: any) =>
    makeApiCall({
      url: "/budget/budgetLineBulkUploadValidate",
      method: "post",
      data,
    }),
  budgetDashboardSiteDropdown: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/budget-dashboard/budgetDashboardSiteDropdown",
      params,
    }),
  budgetDashboardContractorDropdown: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/budget-dashboard/budgetDashboardContractorDropdown",
      params,
    }),
  budgetDashboardCategoryDropdown: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/budget-dashboard/budgetDashboardCategoryDropdown",
      params,
    }),
  budgetLinesDropdown: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/budget/linesDropdown",
      params,
    }),
  sitesIdsWithoutBudget: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/budget/sitesIdsWithoutBudget",
    }),
};

export default budgetApis;
